<template>
  <!-- 顶部操作 面包屑 组件 author: zhangxiaofeng -->
  <div class="operation-crumb f-cb">
    <div class="item f-cb" v-if="items.length>1">
      <a href="javascript: void(0);" class="link" @click="back">返回上级</a>
      <i class="slid"></i>
    </div>
    <div class="item f-cb" v-for="(item, idx) in items" :key="idx">
      <template v-if="items.length - idx <= 4">
        <template v-if="idx < items.length - 1">
          <template v-if="(item.name && item.name.length < 8) || (!item.name)">
            <a href="javascript: void(0);" @click="goTo(idx)" class="link">{{item.name}}</a>
          </template>
          <template v-else>
            <el-tooltip :content="item.name">
              <a href="javascript: void(0);" @click="goTo(idx)" class="link">{{item.name.slice(0,7) + '...'}}</a>
            </el-tooltip>
          </template>
          <i class="w-icon-back default"></i>
        </template>
        <template v-else>
          <a href="javascript: void(0);" @click="goTo(idx)" :class="[searchValue.trim() ? 'link' : 'default']">{{item.name}}</a>
        </template>
      </template>
      <template v-else-if="items.length - idx === 5">
        <a href="javascript: void(0);" @click="goTo(idx)" class="link">...</a>
        <i class="w-icon-back default"></i>
      </template>
      <template v-else></template>
    </div>
    <div class="item f-cb" v-show="searchValue.trim()">
      <i class="w-icon-back default"></i>
      <a href="javascript: void(0);" class="default">搜索“{{searchValue.trim()}}”</a>
    </div>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .operation-crumb {
    font-size: 12px;
    line-height: 24px;

    .item {
      float: left;

      & > span,
      .link {
        max-width: 300px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: default;
      }

      & > * {
        float: left;
      }

      .link {
        color: #2079FA;
        cursor: pointer;
      }

      .w-icon-back {
        font-size: 12px;
        transform: rotate(-180deg);
        margin: 0 5px;
      }

      .slid {
        width: 1px;
        height: 12px;
        background-color: #666;
        margin: 7px 5px 0 7px;
      }

      .default {
        color: rgba(33, 37, 48, 0.8);
        cursor: default;
      }
    }
  }
</style>
<script>
export default {
  name: 'OperationCrumb',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    searchValue: {
      type: String,
      default: ''
    }
  },
  methods: {
    back () {
      if (this.items.length > 1) {
        this.goTo(this.items.length - 2)
      }
    },
    goTo (index) {
      const item = this.items[index]
      if (item) {
        if (item.link) {
          // 情况一: 若当前面包屑节点 包含link字段(外部链接) 则页面直接跳转到该链接
          window.location.href = item.link
        } else if (item.path) {
          // 情况二: 若当前面包屑节点 包含path字段(路由跳转) 则系统内路由跳转 路由参数params {} 可选
          this.$router.push({
            path: item.path,
            params: item.params || {}
          })
        } else {
          // 情况三: 当前节点没有link字段 且 没有path字段 则触发父组件toFolder(当前节点的文件夹路径)
          let str = '/'
          let itemsData = []
          for (let i = 0; i <= index; i++) {
            itemsData.push(this.items[i])
            if (!((this.items[i].name === '全部文件' || this.items[i].name === '计量文件' || this.items[i].name === '计价文件') && i === 0)) {
              str += this.items[i].name
              if (i < index) {
                str += '/'
              }
            }
          }
          this.$emit('change', {
            filepath: str,
            items: itemsData
          })
        }
      }
    }
  }
}
</script>
